/**
 * Знак копилота — четырёхлучевая звезда с глазами.
 *
 * Это тот же знак, что у виджета Dialogic в демке High Level: продукт один,
 * и помощник в нём должен узнаваться с первого взгляда. Контур звезды и
 * посадка глаз взяты оттуда без изменений — рисовать «похоже» нельзя,
 * получится не тот знак.
 */
const STAR = 'M18.046 36c-.568 0-1.048-.411-1.185-.962-.439-1.755-1.278-3.622-2.517-5.601-1.469-2.375-3.563-4.578-6.281-6.609C5.698 21.041 3.333 19.822.969 19.172.409 19.018 0 18.521 0 17.941c0-.57.393-1.061.94-1.217 2.319-.662 4.552-1.737 6.701-3.224 2.468-1.719 4.531-3.781 6.187-6.188C15.293 5.169 16.299 3.049 16.846.953 16.989.403 17.472 0 18.04 0c.574 0 1.061.412 1.2.969.316 1.257.808 2.543 1.479 3.859.844 1.625 1.922 3.188 3.234 4.688 1.344 1.468 2.844 2.797 4.5 3.984 2.164 1.534 4.365 2.612 6.601 3.234.549.152.946.64.946 1.21 0 .578-.409 1.07-.967 1.223-1.417.389-2.876 1.015-4.377 1.88-1.812 1.062-3.5 2.328-5.062 3.797-1.563 1.437-2.844 2.953-3.844 4.547-1.242 1.982-2.082 3.863-2.519 5.644-.136.552-.617.965-1.185.965z'

export function CopilotMark({ size = 30 }: { size?: number }) {
  return (
    <svg
      className="copilot-mark"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="copilot-star" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#f4fbf8" />
        </linearGradient>
      </defs>
      <path d={STAR} fill="url(#copilot-star)" />
      {/* Глаза: изумруд читается и на зелёном шарике, и на бирюзовом. */}
      <g className="copilot-mark__eyes">
        <ellipse cx="18.77" cy="17.74" rx="2.31" ry="5.14" fill="var(--orb-eye)" />
        <ellipse cx="13.11" cy="17.74" rx="2.06" ry="4.63" fill="var(--orb-eye)" />
      </g>
    </svg>
  )
}
